import { FETCH_PRODUCTS } from "../actions/types";

export default function (state = [], action) {
  switch (action.type) {
    case FETCH_PRODUCTS:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/productsReducer.js